import React, { useEffect , useRef } from 'react'
import { BrowserRouter as Router, Route, Outlet} from "react-router-dom";
import GConf from '../generalConf';

//navBar
import NavBar from '../../Dashboard/navBar'

//Main
import MainPage from '../../Dashboard/Main/mainPage';

 
//Stock
import StockPage from '../../Dashboard/Stock/stockPage';
import AddArticleStock from '../../Dashboard/Stock/addArticle';
import ArticleInfo from "../../Dashboard/Stock/articleInfo";
 

//Facture
import FacturePage from "../../Dashboard/Factures/facturePage";
import AjouterFacture from "../../Dashboard/Factures/ajoutreFacture";
import FactureInfo from "../../Dashboard/Factures/infoFacture";
import EditFacture from "../../Dashboard/Factures/editFacture";
import ResumerFactures from '../../Dashboard/Factures/resumerFactures';
import LeftSideCard from '../../Dashboard/leftSide';
 
 

// import { io } from "socket.io-client";
// import { toast } from 'react-toastify';

const SystemLanding = () => {
    /*########### [CONST] ########## */
    // const socket = io.connect(GConf.ApiLinkSoket);
    // const audioRef = useRef(null);

    /*########### [USE EFF] ########## */
    useEffect(() => {
        CheckAuthentification()
        CheckLogIn()
        
    },[]);

    // useEffect(() => {
    //     socket.on('cmd-saved-notif', (data) =>{
    //         toast.error(<><div><h5>Button Cliquer </h5> {data.message} </div></>, GConf.TostInternetGonf) 
    //         audioRef.current.play();
    //     })
    // }, [])

    const CheckAuthentification = () =>{
        const AuthenKey = localStorage.getItem(`Magazin_AuthKeyISSet`);
        if (!AuthenKey) {
            window.location.href = "/Auth";
        }
    }

    const CheckLogIn = () =>{
        const pidIsSet = localStorage.getItem('PID');
        if (!pidIsSet) {window.location.href = "/login";}
    }

    return (<>
        <NavBar/>
        <br />
        <br />
        <br />
        <div className='row pt-4 m-1'>
                <div className='col-12 col-md-12 col-lg-2'><LeftSideCard /></div>
                <div className='col-12 col-md-12 col-lg-10'><Outlet /></div>
        </div>
        {/* <div className="container pt-4">
            <audio ref={audioRef} src="https://assets.ansl.tn/Sound/notification.mp3" />
            <Outlet />
        </div> */}
    </>);
}

const systemRouter = () => (
        <Route path="S" exact element={<SystemLanding />} >
            <Route path="" exact element={<MainPage />} />
            <Route path="ma" exact element={<MainPage />} />
 
            <Route path="sk" exact element={<Outlet />}>
                <Route path="" exact element={<StockPage />} />
                <Route path="ajouter" exact element={<AddArticleStock />} />
                <Route path="info/:code" exact element={<ArticleInfo />} />
            </Route>
            <Route path="ft" exact element={<Outlet />}>
                <Route path="" exact element={<FacturePage />} />
                <Route path="ajouter" exact element={<AjouterFacture />} />
                <Route path="resumer" exact element={<ResumerFactures />} />
                <Route path="info/:FID" exact element={<FactureInfo />} />
            </Route>
             
        </Route>
)

export default systemRouter 